// extracted by mini-css-extract-plugin
export default {"root":"EditModal_root__uxPQK"};